// extracted by mini-css-extract-plugin
module.exports = {"list":"participant-list_list__2EIfw"};